import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface AuditReviewDraft {
  actor: string;
  actionType: string;
  timeWindow: string;
  exportReason: string;
}

@Component({
  selector: 'app-audit',
  templateUrl: './audit.page.html',
  styleUrls: ['./audit.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class AuditPage {
  public auditSuggestions: any[] = [
    { icon: 'bi bi-clipboard2-data', prompt: "Show today's audit events" },
    { icon: 'bi bi-filter', prompt: 'Filter by user Alex' },
    { icon: 'bi bi-download', prompt: 'Export last 24h' },
  ];

  public auditContext: any = {
    page: 'audit',
    purpose: 'Search and analyze audit events',
    filters: {},
    timeRange: 'last_24h',
    outputs: ['Event summary', 'Filter results', 'Export']
  };

  public reviewingAudit = false;
  public auditError = '';
  public auditSuccess = '';
  public hasReviewedAudit = false;
  public auditDraft: AuditReviewDraft = {
    actor: '',
    actionType: '',
    timeWindow: '',
    exportReason: '',
  };

  public readonly actionTypeOptions = ['Authentication', 'Configuration change', 'Data update', 'Permission change'];
  public readonly timeWindowOptions = ['Last 24 hours', 'Last 7 days', 'Last 30 days'];

  constructor() {}

  public async runAuditReview(): Promise<void> {
    this.auditError = '';
    this.auditSuccess = '';
    this.hasReviewedAudit = false;

    if (!this.auditDraft.actionType.trim()) {
      this.auditError = 'Select an action type before running audit review.';
      return;
    }
    if (!this.auditDraft.timeWindow.trim()) {
      this.auditError = 'Select a time window before running audit review.';
      return;
    }

    this.reviewingAudit = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasReviewedAudit = true;
      this.auditSuccess = 'Audit review prepared for export and investigation.';
    } finally {
      this.reviewingAudit = false;
    }
  }
} 